/**
 * Timezones2 will eventually replace timezones.ts
 * we are keeping timezones.ts for now to avoid breaking changes
 * but the current timezone code uses too many custom naming conventions
 * and overly complicates the code.
 */

import { getTimeZones } from '@vvo/tzdb';
import { orderBy } from 'lodash-es';
import { INTERNATIONAL_COUNTRY_CODES, LOCAL_COUNTRY_CODES } from 'core/geography';

// IMPORTANT: These timezones are not supported by the backend
// they should be removed from any list for the frontend!
const depreciatedTimeZones = [
  'America/Adak',
  'America/Atikokan',
  'America/Blanc-Sablon',
]

const SUPPORTED_TIMEZONE_COUNTRY_CODES = [...LOCAL_COUNTRY_CODES, ...INTERNATIONAL_COUNTRY_CODES];

export const GetTimeZones = (countryCodes: string[] = SUPPORTED_TIMEZONE_COUNTRY_CODES) => {
  const tzs = getTimeZones()
    .filter((tz) => countryCodes.includes(tz.countryCode))
    .filter((tz => !depreciatedTimeZones.includes(tz.name)));
  return orderBy(tzs, ['name']);
};

export const GetTimeZoneNames = (countryCodes: string[] = SUPPORTED_TIMEZONE_COUNTRY_CODES) => GetTimeZones(countryCodes)
    .filter((tz) => countryCodes.includes(tz.countryCode))
    .map(t => t.name);
